import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /ui/login-form — REMOVED 2026-09-19.
 *
 * The login-form docs page was renamed to `/ui/form` to
 * reflect that it now covers the full `@osd/ui` form surface
 * (primitives + composites + useForm + LoginForm) rather than
 * just the LoginForm primitive.
 *
 * Old bookmarks + any internal links pointing at the previous URL
 * are redirected here so they keep working.
 */
export const Route = createFileRoute('/ui/_layout/login-form')({
  beforeLoad: () => {
    throw redirect({ to: '/ui/form' });
  },
});
